module.exports = __webpack_public_path__ + "static/carousel.bc70e301.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel.jpg
// module id = 342
// module chunks = 35783957827783